// Core
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { matDialog, MatDialogRef } from '@campfire-nx/material';

// Raptor
import { RaptorActionService } from '../../../resources/raptor-action.service';
import { RaptorAnalyticsService } from '../../../services/raptor-analytics.service';
import { RaptorStepDataService } from '../../../services/raptor-step-data.service';


@Component({
  selector: 'open-raptor-email-quote-interstitial',
  templateUrl: './email-quote-interstitial.component.html',
  styleUrls: ['./email-quote-interstitial.component.scss']
})
export class EmailQuoteInterstitialComponent implements OnInit {
  emailToQuote = new FormControl('');
  sendingQuote = false;
  submittedQuote = false;
  quoteMessage = '';

  constructor(
    private raptorActionService: RaptorActionService,
    private raptorAnalyticsService: RaptorAnalyticsService,
    private raptorStepDataService: RaptorStepDataService,
    public dialogRef: MatDialogRef<EmailQuoteInterstitialComponent>,
    @Inject(matDialog.MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.quoteMessage = '';
    this.submittedQuote = false;
    let stepData = this.raptorStepDataService.get();
    if (stepData && stepData.data && stepData.data.policy_holder_email) {
      this.emailToQuote.setValue(stepData.data.policy_holder_email);
    }
  }

  onSendQuoteClick(): void {
    this.submittedQuote = true;
    this.emailToQuote.setValidators([Validators.required, Validators.email]);
    this.emailToQuote.updateValueAndValidity();

    if (this.emailToQuote.valid) {
      this.sendingQuote = true;

      const payload = {
        email: this.emailToQuote.value
      };

      this.raptorAnalyticsService.trackAdditionalEvents('select-option', 'email'); 

      this.raptorActionService.sendQuote(this.data.settings.action_details, payload)
        .then(response => {
          this.emailToQuote.reset();
          this.submittedQuote = false;
          this.sendingQuote = false;
          this.quoteMessage = response.message;
          this.emailToQuote.setValidators(null);
          this.emailToQuote.updateValueAndValidity();
        })
        .catch(error => {
          this.sendingQuote = false;
          // TODO
          // this.quoteMessage = error.message;
        });
    }
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }
}
